enum DocumentTypes {
  CPF = 'cpf',
  CNPJ = 'cnpj',
}

export default DocumentTypes;
